<div  fxFlex fxLayout="column" fxLayoutAlign="start left">
	<div fxFlex class="mr-3">
		<span class="license-title">{{ 'DoctorSection.License' | translate}}:</span>
	</div>
	<div fxFlex="1 1 100%">
		<span class="license">{{license}}</span>
	</div>
</div>